export function normalizeAssessmentResponse(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (typeof parsed === 'string') return parsed;
      } catch {
        /* keep trimmed */
      }
    }
    return trimmed;
  }

  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'number') return String(value);

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;
    if (record.id != null) return String(record.id);
    if (record.value != null) return String(record.value);
    if (record.optionId != null) return String(record.optionId);
    if (record.response != null) return normalizeAssessmentResponse(record.response);
  }

  return String(value);
}

export function selectedOptionIds(value: unknown): string[] {
  if (Array.isArray(value)) {
    return [...new Set(value.flatMap((item) => {
      const id = normalizeAssessmentResponse(item);
      return id ? [id] : [];
    }))];
  }
  const single = normalizeAssessmentResponse(value);
  return single ? [single] : [];
}

export function isUserOptionSelected(
  option: { id: string; content: string; label?: string },
  response: unknown,
): boolean {
  const selected = selectedOptionIds(response);
  if (selected.length === 0) return false;
  const content = option.content.trim();
  const label = option.label?.trim();
  return selected.some(
    (value) => value === option.id || value === content || (label != null && label !== '' && value === label),
  );
}
